// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainTabBox{padding:5px 10px;border-top-left-radius:8px;border-top-right-radius:8px;background:rgba(186,187,215,.5);background:#fff}.mainTabArea{position:relative;border-bottom:1px solid #4a669e}", ""]);
// Exports
module.exports = exports;
